// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ww-z","contentClass":"Xw-z","active":"Yw-z","unknown":"Zw-z","leftArrow":"_w-z","rightArrow":"ax-z","hasArrows":"bx-z"};